import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';

interface IOrdProps {
    ord: number;
}

export const Wrapper = styled.div`
    display: flex;
    flex-grow: 1;
    justify-self: stretch;
    align-self: stretch;
    position: relative;
`;

export const Chart = styled.svg`
    position: absolute;
`;

const OrdColor = (props: IOrdProps): string => {
    switch (props.ord) {
        case 0:
            return Variables.Colors.b300;
        case 1:
            return '#2464b5';
        case 2:
            return '#1b5d85';
        case 3:
            return '#115654';
        case 4:
            return '#416053';
        case 5:
            return '#706b52';
        case 6:
            return '#a07551';
        case 7:
            return '#cf8050';
        case 8:
            return Variables.Colors.sunset400;
        case 9:
            return Variables.Colors.sunset300;
        default:
            return Variables.Colors.sunset200;
    }
};

export const Rect = styled.rect<IOrdProps>`
    stroke: ${Variables.Colors.n100};
    stroke-opacity: 0.2;
    stroke-width: 0.1px;
    fill: ${OrdColor};
`;
export const Message = styled.text`
    fill: ${Variables.Colors.n100};
    text-anchor: middle;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.2px;
`;
export const Text = styled.text`
    fill: ${Variables.Colors.white};
    letter-spacing: 0.2px;
    font-size: 15px;
`;
export const Pct = styled(Text)`
    font-size: 32px;
`;

export const Tooltip = styled.div`
    display: flex;
    flex-direction: column;
    letter-spacing: 0.2px;
    min-width: 200px;
    align-items: flex-start;
`;
export const TooltipTitle = styled.span<IOrdProps>`
    display: inline-flex;
    flex-grow: 0;
    white-space: nowrap;
    font-size: 18px;
    color: ${Variables.Colors.n100};
    padding-bottom: 3px;
    border-bottom: 3px solid ${OrdColor};
    margin-bottom: 16px;
`;
export const TooltipRow = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    margin-bottom: 4px;
    line-height: 1.57;
    align-self: stretch;
`;
export const TooltipLeft = styled.span`
    color: ${Variables.Colors.n70};
`;
export const TooltipRight = styled.span`
    color: ${Variables.Colors.n100};
`;
